import {EntityApiService, ApiClientService} from '@dofleini/security';

class ClientsApiService extends EntityApiService {

    searchClients = (params) => ApiClientService.post(this.getPath('/parent/search'), params);

    search = (params) => ApiClientService.post(this.getPath('/search'), params);

    searchChildStructures = (params) => ApiClientService.post(this.getPath(`/${params?.parentId}/children`), params);

    getOneClient = ({clientId}) => ApiClientService.get(this.getPath(`/${clientId}`));

    getChildren = ({parentId, ...params}) => ApiClientService.post(this.getPath(`/${parentId}/children`), params);

    delete = ({_id}) => ApiClientService.delete(this.getPath(`/${_id}?cascadeDelete=true`));

    setStructureId = (currentId) => {
      localStorage.setItem('structure-current-id', currentId);
    }

    getStructureId = () => {
      return localStorage.getItem('structure-current-id');
    }

    getAllClients = (params) => {
      return ApiClientService.post(this.getPath('/clients/search'), params);
    };
}

export default new ClientsApiService('/ms-core/api/structures');
